import { render, staticRenderFns } from "./ApprovalMatrixExpand.vue?vue&type=template&id=c9a91692&"
import script from "./ApprovalMatrixExpand.vue?vue&type=script&lang=js&"
export * from "./ApprovalMatrixExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports